import axios from 'axios';
import getCookie from '../util/getCookie';
import { ACCESS_TOKEN_MA, INSTANCE_TOKEN } from './reqConstants';

const loadNavigation = ({ navigationApiUrl, navigationId }) => {
    const tokenMa = getCookie(ACCESS_TOKEN_MA);
    const instanceToken = getCookie(INSTANCE_TOKEN);
    const headers = {
        ...(tokenMa && { Authorization: tokenMa }),
        ...(instanceToken && { Instance: instanceToken })
    };

    const url = `${navigationApiUrl}/v1/navbar/${navigationId}`;

    return axios.get(url, { headers })
        .then(res => (res.data && res.data.data));
};

export default loadNavigation;
